/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'display_number': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" _fill="#333" d="M977.455 884.364H46.545a46.545 46.545 0 010-93.091h93.091v-418.91a372.364 372.364 0 01744.728 0v418.91h93.09a46.545 46.545 0 010 93.09zm-744.728-93.091h558.546v-418.91a279.273 279.273 0 00-558.546 0z"/><path pid="1" _fill="#333" d="M512 1024a164.77 164.77 0 01-162.91-162.91v-23.272a43.753 43.753 0 0146.546-46.545h232.728a43.753 43.753 0 0146.545 46.545v23.273A164.77 164.77 0 01512 1024zm-65.164-139.636A69.818 69.818 0 00512 930.909a65.63 65.63 0 0065.164-46.545z"/>'
  }
})
